export const PROJECT_STATE_OPEN_FOR_INVESTMENT = 11;

export function isInvestOpen(
  state: number | undefined,
  startCollectionDate?: string | null,
  endCollectionDate?: string | null
): boolean {
  if (state == null || state !== PROJECT_STATE_OPEN_FOR_INVESTMENT) return false;
  if (!startCollectionDate || !endCollectionDate) return false;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const today = now.getTime();
  const startTime = new Date(startCollectionDate).setHours(0, 0, 0, 0);
  const endTime = new Date(endCollectionDate).setHours(0, 0, 0, 0);
  return today >= startTime && today <= endTime;
}
